/* ==========================================================================
   BĂNEASA SHOPPING ONLINE — "BLACK FRIDAY · L'ÉDITION NOIRE & OR"
   Single Modular Brand Script (bso-emerald.js)
   Zero external libraries | 1-Click WELCOME20 Auto-Apply | Core Web Vitals
   ========================================================================== */
(function () {
  'use strict';

  /* 0. 1-Click WELCOME20 (-20% First Order) Auto-Apply & Toast Notification */
  function showCouponToast(code) {
    let toast = document.getElementById('bso-coupon-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'bso-coupon-toast';
      toast.className = 'bso-coupon-toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = `<div style="font-weight:800;color:#F5E6B8;margin-bottom:3px;">🎟️ Codul ${code} (−20%) a fost activat!</div><div style="font-size:11.5px;opacity:0.88;">Reducerea de −20% la toată comanda a fost copiată și salvată automat pentru pasul de Checkout.</div>`;
    toast.classList.add('is-visible');
    setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 4200);
  }

  function markCouponActiveUI(code) {
    document.querySelectorAll('[data-bso-coupon-status]').forEach(el => {
      el.textContent = '✓ ACTIVAT (-20%)';
    });
    document.querySelectorAll('[data-bso-coupon-btn-text]').forEach(el => {
      el.textContent = '✓ COD ACTIVAT (-20%)';
    });
  }

  try {
    if (localStorage.getItem('bso_active_coupon') === 'WELCOME20') {
      markCouponActiveUI('WELCOME20');
    }
  } catch (e) {}

  /* 1. Mobile Drawer, Search Bar, Coupon Apply & Interactive 3-Flacon Stage Tabs */
  const drawer = document.getElementById('bso-mobile-drawer');
  const backdrop = document.getElementById('bso-drawer-backdrop');
  const searchBar = document.getElementById('bso-search-bar');

  function openDrawer() {
    if (!drawer || !backdrop) return;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || !backdrop) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    /* 1-Click WELCOME20 Discount Activation */
    const couponBtn = e.target.closest('[data-bso-apply-coupon]');
    if (couponBtn) {
      e.preventDefault();
      const code = couponBtn.getAttribute('data-bso-apply-coupon') || 'WELCOME20';
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).catch(() => {});
        }
        localStorage.setItem('bso_active_coupon', code);
      } catch (err) {}

      // Set Shopify native discount session cookie via background fetch to /discount/WELCOME20
      fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {});
      markCouponActiveUI(code);
      showCouponToast(code);
      return;
    }

    const openBtn = e.target.closest('[data-bso-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }
    const closeBtn = e.target.closest('[data-bso-drawer-close]');
    if (closeBtn || e.target === backdrop) {
      closeDrawer();
      return;
    }
    const searchBtn = e.target.closest('[data-bso-search-toggle]');
    if (searchBtn && searchBar) {
      e.preventDefault();
      searchBar.classList.toggle('is-open');
      if (searchBar.classList.contains('is-open')) {
        const inp = searchBar.querySelector('input[type="search"]');
        if (inp) setTimeout(() => inp.focus(), 60);
      }
      return;
    }

    /* Interactive 3-Flacon Couture Stage Tab Switcher */
    const stageTab = e.target.closest('[data-stage-tab]');
    if (stageTab) {
      const targetIdx = stageTab.getAttribute('data-stage-tab');
      const stageRoot = document.getElementById('bso-hero-stage');
      if (stageRoot && targetIdx) {
        stageRoot.querySelectorAll('[data-stage-tab]').forEach(t => {
          const active = t.getAttribute('data-stage-tab') === targetIdx;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        stageRoot.querySelectorAll('[data-stage-panel]').forEach(p => {
          p.classList.toggle('is-active', p.getAttribute('data-stage-panel') === targetIdx);
        });
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      if (searchBar) searchBar.classList.remove('is-open');
    }
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      if (searchBar) {
        e.preventDefault();
        searchBar.classList.toggle('is-open');
        const inp = searchBar.querySelector('input[type="search"]');
        if (inp) setTimeout(() => inp.focus(), 60);
      }
    }
  });

  /* 2. AJAX Quick Add to Cart (also auto-applies WELCOME20 session if not yet applied) */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-bso-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const origText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span>Se adaugă...</span>';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });
      if (!res.ok) throw new Error('Cart add error');

      // Pre-set WELCOME20 discount cookie for first order convenience
      fetch('/discount/WELCOME20', { credentials: 'same-origin' }).catch(() => {});

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      document.querySelectorAll('[data-bso-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });

      btn.innerHTML = '<span>✓ Adăugat în coș</span>';

      // Refresh Dawn cart-drawer if present
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const sectionRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        const sections = await sectionRes.json();
        if (sections['cart-drawer']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          const newInner = doc.querySelector('#CartDrawer');
          const curInner = document.querySelector('#CartDrawer');
          if (newInner && curInner) {
            curInner.innerHTML = newInner.innerHTML;
          }
          cartDrawer.classList.remove('is-empty');
          cartDrawer.open();
        }
      }

      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = origText;
      }, 1600);
    } catch (err) {
      btn.disabled = false;
      btn.innerHTML = origText;
      window.location.href = '/cart';
    }
  });

  /* 3. Interactive 3-Step Scent Finder Quiz */
  const quizRoot = document.getElementById('bso-scent-quiz');
  if (quizRoot) {
    const state = {
      gender: 'pentru-ea',
      family: 'Oriental',
      budget: ''
    };

    const steps = quizRoot.querySelectorAll('[data-quiz-step]');
    const dots = quizRoot.querySelectorAll('[data-quiz-dot]');
    const resultLink = quizRoot.querySelector('[data-quiz-result-link]');
    const resultSummary = quizRoot.querySelector('[data-quiz-summary]');

    function showStep(num) {
      steps.forEach(s => s.classList.toggle('is-active', s.getAttribute('data-quiz-step') === String(num)));
      dots.forEach(d => d.classList.toggle('is-active', Number(d.getAttribute('data-quiz-dot')) <= Number(num)));
    }

    function updateQuizUrl() {
      if (resultLink) resultLink.setAttribute('href', `/collections/familie-${(state.family || 'oriental').toLowerCase()}`);
      if (resultSummary) {
        const gMap = {
          'pentru-ea': 'Pentru Ea',
          'pentru-el': 'Pentru El',
          'unisex': 'Unisex',
          'nisa-si-lux': 'Nișă & Lux'
        };
        resultSummary.textContent = `${gMap[state.gender] || 'Selecție'} · Nota ${state.family || 'Oriental'}`;
      }
    }

    quizRoot.addEventListener('click', function (e) {
      const opt = e.target.closest('[data-quiz-choice]');
      if (opt) {
        const key = opt.getAttribute('data-quiz-key');
        const val = opt.getAttribute('data-quiz-val');
        const nextStep = opt.getAttribute('data-quiz-next');

        opt.parentElement.querySelectorAll('[data-quiz-choice]').forEach(el => el.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        state[key] = val;
        updateQuizUrl();

        if (nextStep) {
          setTimeout(() => showStep(nextStep), 180);
        }
      }

      const resetBtn = e.target.closest('[data-quiz-reset]');
      if (resetBtn) {
        showStep(1);
      }
    });
  }

  /* 4. Real Dispatch Cutoff & Romanian Delivery Estimator */
  const deliveryNodes = document.querySelectorAll('[data-bso-delivery-estimate]');
  if (deliveryNodes.length > 0) {
    const cutoffHour = 15;
    const now = new Date();
    const day = now.getDay();
    const hr = now.getHours();
    const min = now.getMinutes();

    const daysRo = ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'];
    const monthsRo = ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'];

    let addDays = 1;
    let dispatchText = 'Expediere azi (comandă înainte de 15:00)';

    if (day === 0) {
      addDays = 2;
      dispatchText = 'Expediere Luni la prima oră';
    } else if (day === 6) {
      addDays = 3;
      dispatchText = 'Expediere Luni la prima oră';
    } else if (hr >= cutoffHour) {
      addDays = (day === 5) ? 3 : 2;
      dispatchText = 'Expediere în următoarea zi lucrătoare';
    } else {
      const remH = cutoffHour - 1 - hr;
      const remM = 60 - min;
      dispatchText = `Comandă în ${remH}h ${remM}m pentru expediere azi`;
      addDays = (day === 5) ? 3 : 1;
    }

    const est = new Date(now.getTime() + addDays * 86400000);
    const estFormatted = `${daysRo[est.getDay()]}, ${est.getDate()} ${monthsRo[est.getMonth()]}`;

    deliveryNodes.forEach(node => {
      node.innerHTML = `<strong>Livrare estimată: ${estFormatted}</strong> <span style="opacity:0.8">(${dispatchText})</span>`;
    });
  }

  /* 5. Sticky Mobile ATC Observer on Product Page */
  const stickyAtc = document.getElementById('bso-sticky-atc');
  const mainBuyBtn = document.querySelector('.product-form__submit, [data-bso-main-atc]');
  if (stickyAtc && mainBuyBtn && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    obs.observe(mainBuyBtn);
  }

  /* 6. Lazy-Load Google Maps Iframe when Visible */
  const mapContainers = document.querySelectorAll('[data-bso-lazy-map]');
  if (mapContainers.length > 0 && 'IntersectionObserver' in window) {
    const mapObs = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const src = el.getAttribute('data-map-src');
          if (src && !el.querySelector('iframe')) {
            const iframe = document.createElement('iframe');
            iframe.src = src;
            iframe.width = '100%';
            iframe.height = el.getAttribute('data-map-height') || '260';
            iframe.style.border = '0';
            iframe.style.display = 'block';
            iframe.loading = 'lazy';
            iframe.referrerPolicy = 'no-referrer-when-downgrade';
            iframe.title = 'Hartă Băneasa București';
            el.innerHTML = '';
            el.appendChild(iframe);
          }
          observer.unobserve(el);
        }
      });
    }, { rootMargin: '250px 0px' });
    mapContainers.forEach(c => mapObs.observe(c));
  }
})();
